export default {
  contact: {
    intro: '以下フォームにご記入の上【送信する】ボタンをクリックして下さい。',
    inquiryType: {
      label: 'お問い合わせの種類',
      placeholder: 'お問い合わせの種類を選択してください',
      quote: 'お見積り依頼',
      recruitment: '採用',
      other: 'その他',
    },
    companyName: {
      label: '会社名／学校名',
      placeholder: '株式会社サンプル',
    },
    yourName: {
      label: 'お名前',
      firstName: '姓',
      lastName: '名',
    },
    phone: {
      label: '電話番号',
      placeholder: 'ハイフンやスペースはなしで数字のみ入力ください',
    },
    email: {
      label: 'メールアドレス',
      placeholder: 'your@email.com',
    },
    productInterest: {
      label: '製品名',
      placeholder: '例：水酸化ナトリウム、酸化亜鉛',
    },
    application: {
      label: '見積希望商品（複数可）',
      hint: '例：水酸化ナトリウム、酸化亜鉛',
    },
    destinationPort: {
      label: '仕向港',
      placeholder: '例：上海、ロッテルダム',
    },
    quantityPerShipment: {
      label: '1回あたりの出荷数量',
      placeholder: '例：1 M/T、2 FCL',
    },
    inquiryDetails: {
      label: 'お問合せ内容',
      placeholder: 'ご質問やご要望をできるだけ詳しくご記入ください。',
    },
    hearAbout: {
      label: 'お問合せのきっかけ',
      hint: '（複数選択可）',
      options: ['ホームページ', '検索エンジン', '各種メディア', 'SNS', '求人情報', 'ご紹介', 'イベント', 'その他'],
    },
    privacy: {
      text: 'に同意します。',
      link: 'プライバシーポリシー',
    },
    success: 'お問合せありがとうございます。内容を確認のうえ、担当者よりご返信いたします。',
    error: '送信中にエラーが発生しました。もう一度お試しください。',
    submit: '送信する',
    submitting: '送信中...',
  },
};
